import React, { useEffect } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import * as Yup from 'yup'

import { RefreshZoneRequestDTO } from '@/core/api/dtos/request/zone/refresh'
import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface RefreshZoneModalProps {
	visible: boolean
	onClose: () => void
	onConfirm: (data: RefreshZoneRequestDTO) => void
	isRefreshing: boolean
}

const RefreshZoneModal: React.FC<RefreshZoneModalProps> = ({
	visible,
	onClose,
	onConfirm,
	isRefreshing,
}) => {
	const { t } = useTranslation('common')

	const defaultValues: RefreshZoneRequestDTO = {}

	const validationSchema = Yup.object().shape({})

	const { handleSubmit, reset } = useForm<RefreshZoneRequestDTO>({
		defaultValues,
		resolver: yupResolver(validationSchema),
	})

	useEffect(() => {
		if (!visible) {
			reset(defaultValues)
		}
	}, [visible, reset])

	const onSubmit: SubmitHandler<RefreshZoneRequestDTO> = (data) => {
		onConfirm(data)
	}

	const handleClose = () => {
		if (!isRefreshing) {
			onClose()
		}
	}

	return (
		<Dialog open={visible} onOpenChange={handleClose}>
			<DialogContent
				className="sm:max-w-[480px] p-0 gap-0 overflow-hidden flex flex-col"
				showCloseButton={false}
			>
				<div className="px-6 py-5 border-b">
					<DialogTitle className="text-lg font-medium">
						{t('entities.zone.refresh.title')}
					</DialogTitle>
				</div>

				<form
					onSubmit={handleSubmit(onSubmit)}
					className="flex flex-col flex-1 min-h-0"
				>
					<div className="px-6 py-5 space-y-5">
						<p className="text-sm text-muted-foreground">
							{t('entities.zone.refresh.description')}
						</p>
					</div>

					<div className="px-6 py-5 border-t flex justify-end gap-2">
						<Button
							type="button"
							variant="outline"
							onClick={handleClose}
							disabled={isRefreshing}
							className="rounded-full px-4 h-8 text-xs"
						>
							{t('actions.cancel')}
						</Button>
						<Button
							type="submit"
							disabled={isRefreshing}
							className="rounded-full px-4 h-8 text-xs bg-white text-black hover:bg-gray-100"
						>
							{isRefreshing
								? t('actions.loading')
								: t('entities.zone.refresh.action')}
						</Button>
					</div>
				</form>
			</DialogContent>
		</Dialog>
	)
}

export default RefreshZoneModal
